import _toConsumableArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import config from "@/lib/config";
import { gql } from "@apollo/client";
import Uid2Token from "@/lib/uid2Token";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type Term {\n    term_id: ID!\n    id_key: String\n    display_name: String\n    required: Boolean\n    current_revision: TermRevision\n  }\n\n  type TermRevision @cacheControl(maxAge: 120) {\n    term_revision_id: Int\n    term_id: Int\n    number: Int\n    unique_key: String\n    url: String\n    agreement: TermAgreement\n  }\n\n  type TermAgreement @cacheControl(scope: PRIVATE, maxAge: 120) {\n    agreement_id: Int\n    user_id: Int\n    term_id: Int\n    term_revision_number: Int\n    agreed_at: String\n  }\n\n  enum TermType {\n    REQUIRED\n    OPTIONAL\n  }\n\n  type Query {\n    terms(keys: [String], adult: Boolean, withAgreement: Boolean): [Term]\n    registTerms(adult: Boolean!, type: TermType!): [Term]\n    loginTerms(adult: Boolean!, type: TermType!): [Term]\n  }\n\n  type Mutation {\n    agree(keys: [String]): [TermRevision]\n  }\n"])));
var termTypeValue = {
  REQUIRED: "required",
  OPTIONAL: "optional"
};
export var resolvers = {
  Query: {
    terms: function () {
      var _terms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_parent, _ref, _ref2) {
        var keys, adult, withAgreement, dataSources, results;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                keys = _ref.keys, adult = _ref.adult, withAgreement = _ref.withAgreement;
                dataSources = _ref2.dataSources;
                _context2.next = 4;
                return Promise.all(keys.filter(function (key) {
                  return !adult || adult && !config.terms.ignoreAdult.includes(key);
                }).map( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (adult && config.terms.adultSuffix.includes(key)) {
                              key = "".concat(key, "_adult");
                            }

                            _context.next = 3;
                            return dataSources.terms.getTerm(key, withAgreement);

                          case 3:
                            return _context.abrupt("return", _context.sent);

                          case 4:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x4) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 4:
                results = _context2.sent;
                return _context2.abrupt("return", results);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function terms(_x, _x2, _x3) {
        return _terms.apply(this, arguments);
      }

      return terms;
    }(),
    registTerms: function () {
      var _registTerms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_parent, _ref4, _ref5) {
        var adult, type, dataSources, keys, results;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                adult = _ref4.adult, type = _ref4.type;
                dataSources = _ref5.dataSources;
                keys = config.terms.regist[adult ? "adult" : "vod"][termTypeValue[type]];
                _context4.next = 5;
                return Promise.all(keys.map( /*#__PURE__*/function () {
                  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return dataSources.terms.getTerm(key, true);

                          case 2:
                            return _context3.abrupt("return", _context3.sent);

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x8) {
                    return _ref6.apply(this, arguments);
                  };
                }()));

              case 5:
                results = _context4.sent;
                return _context4.abrupt("return", results);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function registTerms(_x5, _x6, _x7) {
        return _registTerms.apply(this, arguments);
      }

      return registTerms;
    }(),
    loginTerms: function () {
      var _loginTerms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_parent, _ref7, _ref8) {
        var adult, type, req, res, dataSources, keys, userRightIds, filteredKeys, results, adTerm, uid2;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                adult = _ref7.adult, type = _ref7.type;
                req = _ref8.req, res = _ref8.res, dataSources = _ref8.dataSources;
                keys = config.terms.login[adult ? "adult" : "vod"][termTypeValue[type]];

                if (!keys.includes("valueplan_term")) {
                  _context6.next = 7;
                  break;
                }

                _context6.next = 6;
                return dataSources.user.rightIds();

              case 6:
                userRightIds = _context6.sent;

              case 7:
                filteredKeys = keys.filter(function (key) {
                  var _req$userToken;

                  // マイスカパー連携していなければマイスカパーを外す
                  if (!((_req$userToken = req.userToken) !== null && _req$userToken !== void 0 && _req$userToken.mySkpRelation) && key === "myskp") {
                    return false;
                  } // ベーシックパックを購入していなければベーシックパックを外す


                  if (key === "valueplan_term") {
                    return userRightIds.includes(config.valuePlan.rightId);
                  }

                  return true;
                });
                _context6.next = 10;
                return Promise.all(filteredKeys.map( /*#__PURE__*/function () {
                  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(key) {
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.next = 2;
                            return dataSources.terms.getTerm(key, true);

                          case 2:
                            return _context5.abrupt("return", _context5.sent);

                          case 3:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x12) {
                    return _ref9.apply(this, arguments);
                  };
                }()));

              case 10:
                results = _context6.sent;
                adTerm = results.find(function (result) {
                  return result.id_key === config.terms.advertisingTerm;
                });

                if (adTerm) {
                  uid2 = new Uid2Token(req, res);
                  uid2.adTermsAgreeCache(adTerm);
                }

                return _context6.abrupt("return", results);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function loginTerms(_x9, _x10, _x11) {
        return _loginTerms.apply(this, arguments);
      }

      return loginTerms;
    }()
  },
  Mutation: {
    agree: function () {
      var _agree = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_parent, _ref10, _ref11) {
        var keys, dataSources, req, res, results, uid2;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                keys = _ref10.keys;
                dataSources = _ref11.dataSources, req = _ref11.req, res = _ref11.res;
                _context8.prev = 2;
                _context8.next = 5;
                return Promise.all(keys.map( /*#__PURE__*/function () {
                  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(key) {
                    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            return _context7.abrupt("return", dataSources.terms.agree(key));

                          case 1:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));

                  return function (_x16) {
                    return _ref12.apply(this, arguments);
                  };
                }()));

              case 5:
                results = _context8.sent;
                // 規約を更新したらuid2ようにキャッシュしている広告規約の同意状況をクリアする
                uid2 = new Uid2Token(req, res);
                uid2.clearAdTermsAgreeCache();
                return _context8.abrupt("return", results.flatMap(function (result) {
                  return result.term_revisions;
                }));

              case 11:
                _context8.prev = 11;
                _context8.t0 = _context8["catch"](2);
                console.log("terms agree error", _context8.t0);

              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[2, 11]]);
      }));

      function agree(_x13, _x14, _x15) {
        return _agree.apply(this, arguments);
      }

      return agree;
    }()
  },
  Term: {
    required: function required(term) {
      var requiredKeys = [].concat(_toConsumableArray(config.terms.regist.vod.required), _toConsumableArray(config.terms.regist.adult.required), _toConsumableArray(config.terms.login.vod.required), _toConsumableArray(config.terms.login.adult.required));
      return requiredKeys.includes(term.id_key);
    }
  }
};